
export const PublicSellerFaqDoc = new TypedDocumentString(`
    query PublicSellerFaqDoc($slug: String!) {
  publicSellerFaqDoc(slug: $slug) {
    ...SellerFaqQa
    __typename
  }
}
    fragment SellerFaqQa on SellerFaqQa {
  _id
  slug
  document {
    _id
    __typename
  }
  __typename
}`, {"hash":"4087073165bf64809304ea89655b077245043a8186a5c5212291f83a7ebe4024"});